import {ErrorDetail} from 'gen-ts-googleapis/dist/index';

function getErrorTypes(detail: ErrorDetail) {
  switch (detail.type) {
    case 'bad-request':
      return detail.fieldViolations.map(({field}) => field);
    case 'precondition-failure':
      return detail.violations.map(({type}) => type);
  }

  return [];
}

export function getGrpcFieldViolationsAsFormError<T extends string[]>(
  errorDetails: ErrorDetail[],
  fieldsToCheck: T,
) {
  return errorDetails
    .map(getErrorTypes)
    .flat()
    .filter(type => fieldsToCheck.includes(type));
}
